<template>
	<table
		class="table-bordered table-condensed"
		aria-label="previous policy conditions"
	>
		<thead>
			<tr>
				<th scope="col">
					<translate>Valid from</translate>
				</th>
				<th scope="col">
					<translate>Valid until</translate>
				</th>
				<th scope="col">
					<translate>Policy Terms</translate>
				</th>
				<th scope="col">
					<translate>Information Document</translate>
				</th>
				<th
					v-if="productVersions[0][0].domain === 'IE'"
					scope="col"
				>
					Terms of Business
				</th>
			</tr>
		</thead>
		<tbody>
			<tr
				v-for="window of productVersions"
				:key="window[0].id"
			>
				<td :rowspan="window.length">
					{{ formatDate(window[0].validFrom.date, window[0].language, window[0].domain) }}
				</td>
				<td :rowspan="window.length">
					{{ formatDate(window[0].validUntil.date, window[0].language, window[0].domain) }}
				</td>
				<td>
					<a
						v-if="window[0].policyFile"
						:href="'/downloadpolicy?id='+window[0].policyFile.id"
						target="_blank"
					><translate>Policy Terms</translate> {{ window[0].name }}</a>
				</td>
				<td>
					<insurance-card-button
						v-if="window[0].ipidFile"
						:id="window[0].ipidFile.id"
					/>
				</td>
				<td v-if="window[0].domain === 'IE'">
					<a
						v-if="window[0].tobFile"
						:href="'/downloadpolicy/tob?id='+window[0].tobFile.id"
						target="_blank"
					>Terms of Business {{ window[0].name }}</a>
				</td>
			</tr>
			<template
				v-for="version of window.slice(1)"
				:key="version.id"
			>
				<tr>
					<td>
						<a
							v-if="version.policyFile"
							:href="'/downloadpolicy?id='+version.policyFile.id"
							target="_blank"
						><translate>Policy Terms</translate> {{ version.name }}</a>
					</td>
					<td>
						<insurance-card-button
							v-if="version.ipidFile"
							:id="version.ipidFile.id"
						/>
					</td>
					<td v-if="version.domain === 'IE'">
						<a
							v-if="version.tobFile"
							:href="'/downloadpolicy/tob?id='+version.tobFile.id"
							target="_blank"
						>Terms of Business {{ version.name }}</a>
					</td>
				</tr>
			</template>
		</tbody>
	</table>
</template>

<script>
export default {
	name: 'PolicyFileTable',

	props: {
		productVersions: {
			type: Array,
			required: true
		}
	},

	methods: {
		/**
		 * Format a date according to a language and domain
		 *
		 * @param {string} dateString
		 * @param {string} language
		 * @param {string} domain
		 * @returns {string}
		 */
		formatDate (dateString, language, domain) {
			const date = new Date(dateString);

			return date.toLocaleDateString(language + '-' + domain);
		}
	}
};
</script>
